import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "bb5ef3dc-d0c0-44f8-9d9d-6f95ab00fa28", content: "S<sub>1</sub>", options: {} },
  { id: "8b6c1530-efdc-4af3-82a9-0c7d4bb89434", content: "S<sub>2</sub>", options: {} },
  { id: "4752df84-4d8f-48d5-b2a4-11500eb1e171", content: "S<sub>3</sub>", options: {} },
  { id: "9fa04410-59a7-4e2c-b40e-dc1393d6b4b3", content: "S<sub>4</sub>", options: {} },
  { id: "7bf49d99-727a-4c70-844d-d02b5de5ae9a", content: "S<sub>5</sub>", options: {} },
  { id: "783742c5-1ca8-4a42-a0f1-d399c47036f4", content: "S<sub>6</sub>", options: {} },
];

export const task: Task = {
  id: "708b330c-495f-443d-a3b1-a2c2dbd031d2",
  solutionType: "select",
  type: "checkbox",
  options: {
    columns: 1,
    isMultiple: true,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "bb5ef3dc-d0c0-44f8-9d9d-6f95ab00fa28",
    "8b6c1530-efdc-4af3-82a9-0c7d4bb89434",
    "4752df84-4d8f-48d5-b2a4-11500eb1e171",
  ],
};
